module.exports = __webpack_public_path__ + "20292c1222a907c437c3f2fc9abff274.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-flowers.png
// module id = 1883
// module chunks = 0